import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            浏览分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按类型探索galgame资源，找到你最喜欢的作品类别
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 hover:bg-background-200 transition-all duration-300 p-6 cursor-pointer"
            >
              <div className="relative z-10">
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {cat.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{cat.count} 款作品</span>
                  <span className="text-primary-500 group-hover:translate-x-1 transition-transform duration-200">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
              <div className="absolute -right-6 -bottom-6 w-32 h-32 rounded-full bg-primary-100/50 group-hover:bg-primary-100/80 transition-colors duration-300"></div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}